import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Angular Component that show expiration password days remains modal and invite user to change password
 */
@Component({
    selector: 'ap-password-expire-adv',
    templateUrl: './password-expire-adv.modal.component.html'
})
export class PasswordExpireAdvisorModalComponent {

    checkbox = false;

    @Input()
    public expirationDays = 1;

    constructor(
        public activeModal: NgbActiveModal
    ){}

    /**
     * Close modal
     */
    hideAdvise(goToChangePassword: boolean): void {
        this.activeModal.close({hideModal: this.checkbox, goToChangePassword});
    }
}

